import React from 'react';

export default function Badge({ label, color }) {
    return (
        <span className={'btn btn-bold btn-sm btn-font-sm  btn-label-' + color || 'primary'}>
            {label}
        </span>
    );
}
